import React, { useEffect } from 'react'
import './styles.css'

function StartupMessageBanner(props) {
  const {
    message,
    duration,
    persistent,
    onDismiss
  } = props

  useEffect(() => {
    if (!persistent && duration) {
      const timer = setTimeout(() => {
        onDismiss()
      }, duration * 1000)
      
      return () => clearTimeout(timer)
    }
  }, [duration, persistent, onDismiss])

  if (!message) return null

  return (
    <div styleName='startup-message-banner'>
      <div styleName='banner-content'>
        <p styleName='message-text'>{message}</p>
      </div>
    </div>
  )
}

export default StartupMessageBanner

